import React from "react";

const Footer = () => {
  return (
    <>
      <div className="reactweb_section">
        <div className="reactweb_copyright">
          <div className="container">
            <div className="inner">
              <div className="left wow">
                <p>Developed with love by Prince © 2022</p>
              </div>
              <div className="right wow">
                <ul>
                  <li>Terms &amp; Condition</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
